export const schemaGenerator = (key: string): { value: string; text: string }[] =>
    key.split(';').map((pair) => {
        const [value, text] = pair.split(':');
        return { value, text };
    });

export default schemaGenerator;
